import React from 'react';
import ReactTable from 'react-table';
import { fromJS as ImmutableFromJs } from 'immutable';
import PropTypes from 'prop-types';
import RateCardTable from '../../../Common/Components/RateCardTable.jsx'
import { Button, Modal } from 'semantic-ui-react';

export default class RateCardListView extends React.PureComponent {
    render() {
        return (
            <section id="RateCardListView" className="segment">
                <h2>Rate cards</h2>
                {
                    this.renderRateCardResults()
                }
            </section>
        );
    }

    renderRateCardResults = () => {
        const rateCards = this.props.rateCardsToView.toJS();
        if(rateCards.length === 0) {
            return <NoResults />
        } else {
            if(this.props.canDeleteRateCards) {
                return <RateCardTableWithDeleteButton
                    rateCards={ rateCards }
                    onSelectionChanged={ this.onSelectionChanged }
                    onDeleteRequested={ this.onDeleteRequested }/>
            } else {
                return <div>
                        <section className="header-action-section">
                            <div></div>
                            <div className="to-top" onClick={ this.onGoToTopButtonClicked }>Show filters<i className="chevron up icon"></i></div>
                        </section>
                        <RateCardTable rateCards={ rateCards } />
                    </div>
            }
        }
    }

    onSelectionChanged = ({ rateCardIndex, isSelected }) => {
        const rateCard = this.props.rateCardsToView.get(rateCardIndex);
        this.props.onSelectionChanged({ rateCard, isSelected });
    }

    onDeleteRequested = (rateCardIndexes) => {
        this.props.onDeleteRequested(ImmutableFromJs(rateCardIndexes).map(rci => this.props.rateCardsToView.get(rci)));
    }

    static propTypes = {
        rateCardsToView: PropTypes.object.isRequired,
        canDeleteRateCards: PropTypes.bool.isRequired,
        onSelectionChanged: PropTypes.func.isRequired, // onSelectionChanged({ rateCard, isSelected })
        onDeleteRequested: PropTypes.func.isRequired   // onDeleteRequested([rateCards])
    };
}

class RateCardTableWithDeleteButton extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            userClickedDelete: false
        }
    }

    render() {
        const numberOfRateCardsSelected = this.getNumberOfSelectedRateCards();
        return <div>
            <section className="header-action-section">
                <button type="button" disabled={ numberOfRateCardsSelected === 0 } className="button" onClick={ this.onDeleteButtonClicked }>Delete rate cards</button>
                <div>{ numberOfRateCardsSelected === 0 ? 'No' : numberOfRateCardsSelected } { this.getRateCardWording(numberOfRateCardsSelected) } selected for deletion.</div>
                <div className="to-top" onClick={ this.onGoToTopButtonClicked }>Show filters<i className="chevron up icon"></i></div>
            </section>
            <RateCardTable rateCards={ this.props.rateCards } onSelectionChanged={ this.props.onSelectionChanged } />
            <Modal open={this.state.userClickedDelete}>
                <Modal.Header>Delete {this.getRateCardWording(numberOfRateCardsSelected)}</Modal.Header>
                <Modal.Content>
                    {numberOfRateCardsSelected} {this.getRateCardWording(numberOfRateCardsSelected)} will be deleted.<br/><br/>All consignments currently using the deleted {this.getRateCardWording(numberOfRateCardsSelected)} will not be affected unless a recalculation of charges is performed.<br/><br/>This operation cannot be undone.
                </Modal.Content>
                <Modal.Actions>
                    <Button id="ConfirmationDialogApproveButton" onClick={this.onApproveDeleteClicked} primary>Delete selected {this.getRateCardWording(numberOfRateCardsSelected)}</Button>
                    <Button onClick={this.onDenyDeleteClicked}>Cancel</Button>
                </Modal.Actions>
            </Modal>
        </div>
    }

    getRateCardsToDelete() {
        return this.props.rateCards.filter(rc => rc.isSelectedInUi);
    }

    getNumberOfSelectedRateCards() {
        return this.getRateCardsToDelete().length;
    }

    getRateCardWording(numberOfRateCardsSelected /* optional */) {
        if(numberOfRateCardsSelected === undefined)
            numberOfRateCardsSelected = getNumberOfSelectedRateCards();
        return numberOfRateCardsSelected === 1 ? 'rate card' : 'rate cards';
    }

    onGoToTopButtonClicked = () => {
        window.scrollTo(0, 0);
    }

    onDeleteButtonClicked = () => {
        this.setState({ userClickedDelete: true});
    }

    onDenyDeleteClicked = () => {
        this.setState({ userClickedDelete: false});
    }

    onApproveDeleteClicked = () => {
        this.setState({ userClickedDelete: false});

        this.props.onDeleteRequested(this.getRateCardsToDelete().map(rc => this.props.rateCards.indexOf(rc)))
    }
}

const NoResults = () => (
    <div className="no-results">
        No rate cards matched the specified search criteria.
    </div>
)
